import PropTypes from 'prop-types'
import React from 'react'
import withTranslation from 'next-translate/withTranslation'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { getListings } from 'SRC/modules/ads/lisitings/selectors'
import { Item } from 'SRC/modules/ads/add/components/FormPage/PromoPeriods/Item'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { getAdForPromo, getUserInfo } from '../../selectors'
import { setProfileLoading, setActivatePromoError, setNotifications } from '../../actions'
import Router from 'next/router'
import { listingStatuses } from 'SRC/modules/ads/lisitings/constants'
import { notificationTypes, profileMenu } from '../../constants'

export class PromoPeriods extends React.PureComponent {

  constructor (props) {
    super(props)

    const isListingStatusPending = props.ad?.listingStatus === listingStatuses.PENDING

    let activeListing = null

    if (isListingStatusPending) {
      activeListing = props.ad.listing
    }

    this.state = {
      activeListing
    }
  }

  onListingChange = event => {
    const value = Number(event.target.dataset.id)
    this.setState({...this.state, activeListing: value})
  }

  onPromoActivate = async event => {
    event.preventDefault()
    const { ad, user, listings, setProfileLoading, setActivatePromoError, setNotifications } = this.props

    const helper = new CookiesHelper()
    const token = helper.get('token')
    const userId = helper.get('userId')
    const listing = this.state.activeListing

    if (token && userId && listing && ad) {
      await setProfileLoading(true)

      let status, message
      const api = new AdApi()

      let promoRequestId

      if (ad.listingStatus === listingStatuses.PENDING) {
        const fields = {token, userId, promoRequestId: ad.promoRequest, listing}
        const response = await api.updatePromo(fields)

        status = response.status
        message = response.message

        promoRequestId = ad.promoRequest
      } else {
        const fields = {token, userId, adId: ad.id, listing}
        const response = await api.promote(fields)

        status = response.status
        promoRequestId = response.promoRequest
        message = response.message
      }

      if (status === AdApi.responseTypes.OK) {
        const hrefUrl = `/profile`
        const asUrl = `/profil/${profileMenu.ads.code}`
        const query = {page: profileMenu.ads.code}
        const selectedListing = listings.filter(item => item.id === listing)
        if (selectedListing.length) {
          const notifications = []

          notifications.push({
            type: notificationTypes.USER_ADDED_PAID_AD,
            info: {
              ad: {code: ad.code, listing: selectedListing[0], promoRequest: promoRequestId},
              user: user
            }
          })

          setNotifications(notifications)
        }
        setTimeout(() => {
          Router.push({pathname: hrefUrl, query}, {pathname: asUrl}).then(() => window.scrollTo(0, 0))
        }, 5000)
      } else {
        setActivatePromoError(message)
        setProfileLoading(false)
      }
    }
  }

  render () {
    const { listings, i18n: { t } } = this.props

    return (
      <form className='dodavanje-oglasa-form-podaci' onSubmit={this.onPromoActivate}>
        <div className='tipovi-oglasa'>
          {listings.map(item =>
            <Item {...item} key={item.id} onClick={this.onListingChange} activeType={this.state.activeListing} />
          )}
        </div>
        <button className='btn-oglas-submit ads-add__submit' type='submit' disabled={!this.state.activeListing}>
          {t('common:Pošalji zahtjev')}
        </button>
      </form>
    )
  }
}

const mapStateToProps = state => ({
  listings: getListings(state).filter(item => item.price > 0),
  ad: getAdForPromo(state),
  user: getUserInfo(state)
})

PromoPeriods.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired),
  ad: PropTypes.shape({
    id: PropTypes.number.isRequired,
    code: PropTypes.string.isRequired
  }),
  setActivatePromoError: PropTypes.func.isRequired,
  setProfileLoading: PropTypes.func.isRequired,
  setNotifications: PropTypes.func.isRequired,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    surname: PropTypes.string
  }).isRequired
}

const enhance = compose(
  withTranslation,
  connect(mapStateToProps, {setProfileLoading, setActivatePromoError, setNotifications})
)

export default enhance(PromoPeriods)
